import React from "react";
import XIcon from "../../Icons/XIcon";
import { createUseStyles } from "react-jss";

const useStyles = createUseStyles((theme) => ({
  cornerBackButtonWrapper: {
    position: "absolute",
    top: "-10px",
    left: "-10px",
    backgroundColor: theme.secondaryColor,
    width: "50px",
    height: "50px",
    borderRadius: "30px",
    zIndex: "5",
    transition: "all 0.1s ease-in-out",
    "&:hover": {
      backgroundColor: theme.primaryColor,
      cursor: "pointer",
    },
    "&:active": { backgroundColor: theme.secondaryColor },
  },
  icon: {
    position: "relative",
    left: "21px",
    top: "21px",
  },
}));

export default ({ className, handleClick }) => {
  const styles = useStyles();
  return (
    <div
      className={[styles.cornerBackButtonWrapper, className].join(" ")}
      onClick={handleClick}
    >
      <XIcon className={styles.icon} />
    </div>
  );
};
